"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.medals = void 0;
var _bronze = _interopRequireDefault(require("../../assets/images/medals/bronze.svg"));
var _gold = _interopRequireDefault(require("../../assets/images/medals/gold.svg"));
var _silver = _interopRequireDefault(require("../../assets/images/medals/silver.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const medals = exports.medals = [{
  color: '#ffe27d',
  icon: _gold.default
}, {
  color: '#dde0e7',
  icon: _silver.default
}, {
  color: '#ffb48b',
  icon: _bronze.default
}];